import { Entity } from 'src/interfaces/banking';

export const getEntityFromEntities = (entityUri: string, entitites: Entity[]) => entitites.find(ent => ent._links?.self?.uri === entityUri);
